import NavBar from './NavBar';
import Display from './Display';

const Home = () => {
    return (
        <div className="App-header">
            <NavBar />
            <div className="generator-display">
                <Display />
            </div>
        </div>
    );
};

export default Home;
